import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import { ILinkedAccount, ISummaryData } from '../../../types';
import { useStore } from '../../../store';
import { STYLE, TEXT } from '../constants';
import { FlowContext } from '../pages';
import { convertValueToUSD } from '../../../helpers/currency.helper';
import LottieAsset from '../../../assets/lotties/time_watch.json';
import Lottie from '../../../generic-components/Lottie';

const {
  PAGES: {
    POST_LINKED: {
      MONEY_TRANSFER: {
        CONFIRMATION_MODAL_CONTENT: { TRANSFER_DETAILS },
      },
    },
  },
} = STYLE;
const {
  PAGES: {
    POST_LINKED: {
      MONEY_TRANSFER: { USER_MESSAGE },
    },
  },
} = TEXT;

interface IProps {
  transferValue: string;
  linkAccountData: ILinkedAccount;
  estimatedArrival: string;
  firstTimeMessage?: string;
}

export const TransferDetails = ({ transferValue, linkAccountData, estimatedArrival, firstTimeMessage }: IProps) => {
  const summaryData: ISummaryData = useStore((state) => state.summary);

  const { getPrimaryAccount } = useStore((state) => state);
  const isAddMoneyFlow = useContext(FlowContext);
  const { t } = useTranslation();
  const name = `${summaryData.customer.firstName}  ${summaryData.customer.lastName}`;
  const { routingNumber } = getPrimaryAccount();
  const addMoneyToSubHeader = ` ${t(USER_MESSAGE.ADD_MONEY_TO_SUB_HEADER)}, ${routingNumber} `;
  const linkedAccountRoutingNumber = `${t('ROUTING_NUMBER_STRING')}, ${linkAccountData.routingNumber}`;
  return (
    <div className={TRANSFER_DETAILS.WRAPPER}>
      <div className={TRANSFER_DETAILS.AMOUNT.WRAPPER}>
        <Heading title={t(USER_MESSAGE.AMOUNT)} className={TRANSFER_DETAILS.AMOUNT.HEADING_1} />
        <Heading
          title={convertValueToUSD(JSON.parse(transferValue), 2)}
          className={TRANSFER_DETAILS.AMOUNT.HEADING_2}
        />
      </div>

      <div className={TRANSFER_DETAILS.FROM.WRAPPER}>
        <Heading title={t(USER_MESSAGE.FROM)} className={TRANSFER_DETAILS.FROM.HEADING_1} />
        <div className={TRANSFER_DETAILS.FROM.INNER_WRAPPER}>
          <Heading
            title={isAddMoneyFlow ? linkAccountData.institutionName : t(USER_MESSAGE.CHECKING_ACCOUNT)}
            className={TRANSFER_DETAILS.FROM.HEADING_2}
          />
          {isAddMoneyFlow && (
            <Heading
              title={`${linkAccountData.displayName}, ${linkAccountData.mask}`}
              className={TRANSFER_DETAILS.FROM.HEADING_3}
            />
          )}
          <Heading title={linkedAccountRoutingNumber} className={TRANSFER_DETAILS.FROM.HEADING_3} />
        </div>
      </div>
      <div className={TRANSFER_DETAILS.SPLITTER} />
      <div className={!isAddMoneyFlow ? TRANSFER_DETAILS.TO.WRAPPER_SEND_MONEY : TRANSFER_DETAILS.TO.WRAPPER}>
        <Heading title={t(USER_MESSAGE.TO)} className={TRANSFER_DETAILS.TO.HEADING_1} />
        <div className={TRANSFER_DETAILS.TO.INNER_WRAPPER}>
          <Heading
            title={isAddMoneyFlow ? name : linkAccountData.institutionName}
            className={TRANSFER_DETAILS.TO.HEADING_2}
          />
          <Heading
            title={isAddMoneyFlow ? addMoneyToSubHeader : `${linkAccountData.displayName}, ${linkAccountData.mask}`}
            className={TRANSFER_DETAILS.TO.HEADING_3}
          />
        </div>
      </div>

      {isAddMoneyFlow && (
        <div className={TRANSFER_DETAILS.ESTIMATE.WRAPPER}>
          <div className='flex items-center justify-between'>
            <Heading title={t(USER_MESSAGE.ESTIMATE)} className={TRANSFER_DETAILS.ESTIMATE.HEADING_1} />
            <Heading title={estimatedArrival} className={TRANSFER_DETAILS.ESTIMATE.HEADING_2} />
          </div>
          {firstTimeMessage && (
            <div className='py-[8px] w-full flex flex-col items-center justify-center rounded-[8px] bg-action00 mt-[10px]'>
              <Lottie lottieAsset={LottieAsset} isLoop={false} isAutoplay className='mb-[10px] w-[28px]' />
              <Heading
                title={firstTimeMessage}
                className='max-w-[276px] font-metricR text-[14px] text-bw08 text-center'
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
